<!-- aka call to action entry -->
<template>
    <div class="journal-entry" :class="[entry ? 'journal-entry-' + entry.type : '', 'journal-entry-callToActionEntry' ]">
        <template v-if="entry">
            <event-entry-header :entry="entry" animate-content="false" :show-content="showPageHeaderContent" :key="entry.id"></event-entry-header>
            <div class="entry-content event-entry-content" ref="entryContent">
                <div class="content-blocks">
                    <journal-entry-meta :entry="entry"></journal-entry-meta>
                </div>
                <div class="content-blocks">
                    <component v-for="(element, index) in entry.contentBlocks" :key="'element-' + index" :is="element.type" :block="element" :theme-color="this.entry && this.entry.theme ? 'theme-custom-colors' : null" :class="element.backgroundColor ? 'bg-' + element.backgroundColor : ''"></component>
                </div>
            </div>
        </template>
        <Spinner v-else />
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import EventEntryHeader from '@/components/journal/EventEntryHeader';
import JournalEntryMeta from '@/components/journal/JournalEntryMeta';
import Spinner from '@/components/Spinner';
import accordeon from '@/components/contentBlocks/Accordeon';
import imageSingle from '@/components/contentBlocks/ImageSingle';
import textStandard from '@/components/contentBlocks/TextStandard';
import infoBox from '@/components/contentBlocks/InfoBox';
import images2Cols from '@/components/contentBlocks/Images2Cols';
import imageGallery from '@/components/contentBlocks/ImageGallery';
import divider from '@/components/contentBlocks/Divider';
import quote from '@/components/contentBlocks/Quote';
import person from '@/components/contentBlocks/Person';
import additionalLinks from '@/components/contentBlocks/AdditionalLinks';
import interview from '@/components/contentBlocks/Interview';
import spacer from '@/components/contentBlocks/Spacer';
import youtubeVideo from '@/components/contentBlocks/YoutubeVideo';
import audioNative from '@/components/contentBlocks/AudioNative';
import podcast from '@/components/contentBlocks/Podcast';
import iframe from '@/components/contentBlocks/Iframe';
import imageLink from '@/components/contentBlocks/ImageLink';
import infoDropdown from '@/components/contentBlocks/InfoDropdown';
import mediaTeaser from '@/components/contentBlocks/MediaTeaser';
import coachingPoolList from '@/components/contentBlocks/CoachingPoolList';
import buttonLinks from '@/components/contentBlocks/ButtonLinks';

import { Coaching } from '@/http/Coaching';
import InternalLinkReplacementMixin from '@/mixins/InternalLinkReplacementMixin';
export default {
    name: 'EventEntry',
    components: {
        EventEntryHeader,
        JournalEntryMeta,
        Spinner,
        textStandard,
        accordeon,
        imageSingle,
        infoBox,
        images2Cols,
        imageGallery,
        divider,
        quote,
        person,
        additionalLinks,
        interview,
        spacer,
        youtubeVideo,
        podcast,
        iframe,
        imageLink,
        audioNative,
        infoDropdown,
        mediaTeaser,
        coachingPoolList,
        buttonLinks
    },
    mixins: [InternalLinkReplacementMixin],
    data() {
        return {
            entry: null,
            prevRoute: null,
            pageInitT: false,
            enterTransitionFinished: false,
            showPageHeaderContent: false,
            linksInited: false
        };
    },
    computed: {
        ...mapGetters({
            view: 'view/get',
        }),
    },
    mounted() {
        this.preparePageContent();
        this.getCoachingEntry();
    },
    unmounted() {
        this.resetPageContent();
    },
    activated() {
        this.preparePageContent();
    },
    deactivated() {
        this.resetPageContent();
    },
    updated() {
        this.$nextTick(() => {
            if (this.entry && !this.linksInited) {
                this.initInternalLinks(this.$refs.entryContent);
                this.linksInited = true;
            }
        });
    },
    methods: {
        async getCoachingEntry() {
            try {
                var response = await Coaching.get(this.$route.params.slug);
                this.entry = response.data;
                // set Theme
                if (this.enterTransitionFinished) {
                    this.$nextTick(function () {
                        this.initPageContent();
                    });
                }
            } catch {
                this.$push('');
            }
        },
        preparePageContent() {
            if (this.pageInitT) {
                clearTimeout(this.pageInitT);
            }
            var that = this;
            this.pageInitT = setTimeout(function () {
                that.enterTransitionFinished = true;
                if (that.entry) {
                    that.$nextTick(function () {
                        that.initPageContent();
                    });
                }
            }, that.view.transition.duration);
            that.$store.commit('view/setTransitionDuration', 0);
        },
        initPageContent() {
            if (this.entry && this.entry.theme) {
                this.$el.classList.add('theme-custom-colors');
                this.$store.commit('view/setPageClass', 'theme-custom-colors');
                this.$store.commit('view/setPageCssVars', this.entry.theme);
            }
            if (this.entry && this.entry.metaData) {
                this.$setHeaderData(this.entry.metaData);
            }
            if (this.entry && this.entry.parent) {
                this.$store.commit('navigation/setPageRoot', this.entry.parent);
            }
            if (this.entry && this.entry.languageLinks) {
                this.$store.commit('navigation/setLangNav', this.entry.languageLinks);
            }
            this.showPageHeaderContent = true;
        },
        resetPageContent() {
            this.enterTransitionFinished = false;
            this.showPageHeaderContent = false;
            if (this.pageInitT) {
                clearTimeout(this.pageInitT);
                this.pageInitT = false;
            }
            if (this.entry && this.entry.theme) {
                this.$el.classList.remove('theme-custom-colors');
            }
        },
    },
};
</script>